import Dashboard from "../pages/Dashboard";
import Login from "../pages/auth/LoginPage";
import ListPayments from "../pages/payment/List";
import CreatePayment from "../pages/payment/Create";
import ListPaymentRecords from "../pages/payment/ListPaymentRecords";

const Routes = [
  {
    path: "/",
    name: "login",
    exact: true,
    pageTitle: "Login",
    component: Login,
  },
  {
    path: "/dashboard",
    name: "",
    exact: true,
    pageTitle: "",
    component: Dashboard,
  }, 
  {
    path: "/payment-records/:id",
    exact: true,
    component: ListPaymentRecords
  },
  {
    path: "/payments",
    exact: true,
    component: ListPayments,
  },
  {
    path: "/create-payment",
    exact: true,
    component: CreatePayment
  },
];

export default Routes;
